import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ZatcaPhaseTwoComponent } from '@teem/zatca-phase-two-module/zatca-phase-two.component';

const routes: Routes = [
  {
    path: '',
    component: ZatcaPhaseTwoComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ZatcaPhaseTwoRoutingModule { }
